export function isLegacyDutyExcelHeader(header) {
  if (!Array.isArray(header) || String(header[0] || '').trim() !== '客服昵称') return false;
  const date = header[1];
  if (typeof date === 'number') return date > 0 && date <= 2958465;
  return /^\d{4}[-_\/.]\d{1,2}[-_\/.]\d{1,2}$/.test(String(date || '').trim());
}
